module.exports = __webpack_public_path__ + "static/img/about-bg.64eb1c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/about-bg.png
// module id = 2u8l
// module chunks = 36